import { useEffect, useState } from 'react';
import { getProfileEmail, isProfileSyncEnabled, pullProfileControls } from '../lib/profileSync.js';

export function useProfileSync() {
  const [status, setStatus] = useState('');

  useEffect(() => {
    let cancelled = false;

    void pullProfileControls().then((result) => {
      if (cancelled) return;
      if (result.syncEnabled && result.ok) {
        const who = getProfileEmail();
        const label = who && who !== 'legacy' ? who : 'conta';
        setStatus(
          result.merged
            ? `Controlos sincronizados (${result.merged} consola${result.merged === 1 ? '' : 's'}) — ${label}`
            : `Perfil ligado — ${label}`,
        );
      } else if (result.reason === 'unauthenticated') {
        setStatus('');
      } else if (!isProfileSyncEnabled()) {
        setStatus('');
      }
    });

    const flush = () => {
      import('../lib/profileSync.js')
        .then(({ flushProfileControlsPush }) => flushProfileControlsPush())
        .catch(() => {});
    };
    window.addEventListener('beforeunload', flush);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') flush();
    });

    return () => {
      cancelled = true;
      window.removeEventListener('beforeunload', flush);
      flush();
    };
  }, []);

  return { profileStatus: status, syncEnabled: isProfileSyncEnabled() };
}
